import React, { useEffect, useState } from "react";
import AdminLayout from "./Common/AdminLayout";
import LoadingSkeleton from "./Common/LoadingSkeleton";
import { FaPlus, FaTimes } from "react-icons/fa";
import {
  CreatePackage,
  DeletePackage,
  GetPackage,
} from "../../Redux/Slices/Package";
import toast from "react-hot-toast";
import "../../asset/new/css/admin-modern.css";

const Subscription = () => {
  const [packageDetails, setPackageDetails] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [formdata, setFormdata] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [addModalOpen, setAddModalOpen] = useState(false);
  // Onchange
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormdata({ ...formdata, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" });
  };

  // Validation function
  const validateForm = () => {
    let errors = {};
    let isValid = true;

    // Validate Package Name
    if (!formdata.name) {
      errors.type = "Package Name is required";
      isValid = false;
    }
    if (!formdata.type) {
      errors.type = "Package Type is required";
      isValid = false;
    }

    // Validate Validity Day
    if (!formdata.validity_day) {
      errors.validity_day = "Validity Day should be filled";
      isValid = false;
    }

    // Validate Offer
    // if (!formdata.offer) {
    //   errors.offer = "Offer Text is required";
    //   isValid = false;
    // }

    // Validate Cost
    if (!formdata.cost) {
      errors.cost = "Package Price should be filled";
      isValid = false;
    }

    // Validate No of Job Posting
    if (!formdata.no_job_posting) {
      errors.no_job_posting = "No of Job Posting should be filled";
      isValid = false;
    }

    // Validate No of CV Search
    if (!formdata.no_cv_search) {
      errors.no_cv_search = "No Of CV Search should be filled";
      isValid = false;
    }

    // Validate Discount Percentage
    // if (
    //   formdata.discount &&
    //   (formdata.discount < 0 || formdata.discount > 100)
    // ) {
    //   errors.discount = "Discount Percentage should be between 0 and 100";
    //   isValid = false;
    // }

    setFormErrors(errors);
    return isValid;
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly");
      return;
    }
    let data = {
      name: formdata?.name,
      type: formdata?.type,
      no_job_posting: Number(formdata?.no_job_posting),
      no_cv_search: Number(formdata?.no_cv_search),
      validity_day: Number(formdata?.validity_day),
      offer: formdata?.offer,
      discount: Number(formdata?.discount),
      cost: Number(formdata?.cost),
      gst: 0,
    };
    try {
      await CreatePackage(data);
      await packageData();
      setAddModalOpen(false);
      resetForm();
      toast.success("Package created successfully");
    } catch (error) {
      toast.error("Failed to create package");
    }
  };

  //Delete Package
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this package?")) return;
    try {
      await DeletePackage(id);
      await packageData();
      toast.success("Package deleted successfully");
    } catch (error) {
      toast.error("Failed to delete package");
    }
  };

  const packageData = async () => {
    try {
      setLoading(true);
      let data = await GetPackage();
      setPackageDetails(data?.docs);
    } catch (error) {
      console.error("Error fetching package data:", error);
      toast.error("Failed to load packages");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    packageData();
    document.title = "Subscriptions | Admin";
  }, []);

const resetForm = () => {
  setFormdata({
    name: "",
    type: "",
    validity_day: "",
    offer: "",
    cost: "",
    no_job_posting: "",
    no_cv_search: "",
    discount: "",
    gst: "",
  });
  setFormErrors({});
  setSearchQuery("");
};




  return (
    <AdminLayout
      title="Subscription Packages"
      subtitle="Manage subscription plans and pricing"
      actions={
        <button
          onClick={() => {
            resetForm();
            setAddModalOpen(true);
          }}
          className="admin-btn admin-btn-primary"
        >
          <FaPlus className="me-2" />
          Add Package
        </button>
      }
    >
      {/* Search Bar */}
      <div className="admin-card" style={{ marginBottom: 'var(--spacing-xl)' }}>
        <div className="admin-card-body">
          <input
            type="search"
            placeholder="Search packages..."
            className="admin-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ maxWidth: "500px" }}
          />
        </div>
      </div>

      {/* Table Card */}
      <div className="admin-card">
        <div className="admin-card-body">
          <div className="admin-table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Package Name</th>
                  <th>Offer Text</th>
                  <th>Price (₹)</th>
                  <th>Discount (%)</th>
                  <th>GST (₹)</th>
                  <th>Total Price (₹)</th>
                  <th>CV Search</th>
                  <th>Job Post</th>
                  <th>Validity (Days)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkeleton type="table-row" count={5} columns={11} />
                ) : packageDetails.length > 0 ? (
                  packageDetails
                    .filter((item) =>
                      item?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
                      item?.type?.toLowerCase()?.includes(searchQuery?.toLowerCase())
                    )
                    .map((item, index) => (
                      <tr key={item._id}>
                        <td>
                          <span className="admin-badge admin-badge-light">
                            {index + 1}
                          </span>
                        </td>
                        <td>
                          <div style={{ fontWeight: "600" }}>{item?.name}</div>
                          <div style={{ fontSize: "0.875rem", color: "var(--admin-text-secondary)" }}>
                            {item?.type}
                          </div>
                        </td>
                        <td>{item?.offer || "-"}</td>
                        <td>₹{item?.cost}</td>
                        <td>
                          {item?.discount ? (
                            <span className="admin-badge admin-badge-success">
                              {item?.discount}%
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>₹0</td>
                        <td style={{ fontWeight: "600" }}>₹{item?.cost || 0}</td>
                        <td>
                          <span className="admin-badge admin-badge-info">
                            {item?.no_cv_search || 0}
                          </span>
                        </td>
                        <td>
                          <span className="admin-badge admin-badge-info">
                            {item?.no_job_posting || 0}
                          </span>
                        </td>
                        <td>{item?.validity_day} days</td>
                        <td>
                          <button
                            type="button"
                            className={`admin-btn admin-btn-sm ${
                              item?.is_active ? "admin-btn-danger" : "admin-btn-success"
                            }`}
                            onClick={() => handleDelete(item?._id)}
                          >
                            {item?.is_active ? "Deactivate" : "Activate"}
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="11">
                      <div className="admin-empty-state">
                        <i className="fas fa-box fa-3x mb-3"></i>
                        <h4>No Packages Found</h4>
                        <p>Create your first subscription package to get started.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add Package Modal */}
      {addModalOpen && (
        <div className="admin-modal-backdrop" onClick={() => setAddModalOpen(false)}>
          <div 
            className="admin-modal" 
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "600px" }}
          >
            <div className="admin-modal-header">
              <h3>Add Subscription Package</h3>
              <button onClick={() => setAddModalOpen(false)} className="admin-modal-close">
                <FaTimes />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="admin-modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="admin-form-group">
                      <label className="admin-form-label">Package Name *</label>
                      <input
                        type="text"
                        name="name"
                        className="admin-input"
                        placeholder="e.g., Basic Plan"
                        value={formdata?.name || ""}
                        onChange={handleInputChange}
                      />
                      {formErrors?.name && (
                        <span style={{ color: "var(--admin-danger)", fontSize: "0.875rem" }}>
                          {formErrors.name}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="admin-form-group">
                      <label className="admin-form-label">Package Type *</label>
                      <select
                        name="type"
                        className="admin-input"
                        value={formdata?.type || ""}
                        onChange={handleInputChange}
                      >
                        <option value="">Select Type</option>
                        <option value="CV search">CV Search</option>
                        <option value="Job post">Job Post</option>
                        <option value="Both">Both</option>
                      </select>
                      {formErrors?.type && (
                        <span style={{ color: "var(--admin-danger)", fontSize: "0.875rem" }}>
                          {formErrors.type}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="admin-form-group">
                      <label className="admin-form-label">Price (₹) *</label>
                      <input
                        type="number"
                        name="cost"
                        className="admin-input"
                        placeholder="e.g., 5000"
                        value={formdata?.cost || ""}
                        onChange={handleInputChange}
                      />
                      {formErrors?.cost && (
                        <span style={{ color: "var(--admin-danger)", fontSize: "0.875rem" }}>
                          {formErrors.cost}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="admin-form-group">
                      <label className="admin-form-label">Validity (Days) *</label>
                      <input
                        type="number"
                        name="validity_day"
                        className="admin-input"
                        placeholder="e.g., 30"
                        value={formdata?.validity_day || ""}
                        onChange={handleInputChange}
                      />
                      {formErrors?.validity_day && (
                        <span style={{ color: "var(--admin-danger)", fontSize: "0.875rem" }}>
                          {formErrors.validity_day}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="admin-form-group">
                      <label className="admin-form-label">Job Postings *</label>
                      <input
                        type="number"
                        name="no_job_posting"
                        className="admin-input"
                        placeholder="e.g., 10"
                        value={formdata?.no_job_posting || ""}
                        onChange={handleInputChange}
                      />
                      {formErrors?.no_job_posting && (
                        <span style={{ color: "var(--admin-danger)", fontSize: "0.875rem" }}>
                          {formErrors.no_job_posting}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="admin-form-group">
                      <label className="admin-form-label">CV Searches *</label>
                      <input
                        type="number"
                        name="no_cv_search"
                        className="admin-input"
                        placeholder="e.g., 50"
                        value={formdata?.no_cv_search || ""}
                        onChange={handleInputChange}
                      />
                      {formErrors?.no_cv_search && (
                        <span style={{ color: "var(--admin-danger)", fontSize: "0.875rem" }}>
                          {formErrors.no_cv_search}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="admin-form-group">
                      <label className="admin-form-label">Discount (%)</label>
                      <input
                        type="number"
                        name="discount"
                        className="admin-input"
                        placeholder="e.g., 10"
                        value={formdata?.discount || ""}
                        onChange={handleInputChange}
                        min="0"
                        max="100"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="admin-form-group">
                      <label className="admin-form-label">GST Amount</label>
                      <input
                        type="text"
                        className="admin-input"
                        value="₹0"
                        disabled
                        style={{ background: "var(--admin-bg-secondary)", cursor: "not-allowed" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="admin-form-group">
                  <label className="admin-form-label">Offer Text</label>
                  <textarea
                    name="offer"
                    className="admin-input"
                    rows="3"
                    placeholder="e.g., Best value for growing businesses"
                    value={formdata?.offer || ""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="admin-modal-footer">
                <button
                  type="button"
                  onClick={() => setAddModalOpen(false)}
                  className="admin-btn admin-btn-secondary"
                >
                  Cancel
                </button>
                <button type="submit" className="admin-btn admin-btn-primary">
                  Create Package
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default Subscription;
